<template>

    <div class="">

        <button
            type="button"
            class="btn btn-primary w-100 mb-4 sticky-button"
            :class="{ 'is-sticky': isSticky }"
            @click="addDuplicate"
            ref="duplicateButton"
            style="position: sticky;top: 75px;z-index: 100; height: 60px;"
        >
            Add Another Duplicate
        </button>

        <div v-for="(duplicate, index) in duplicates" :key="index">
            <AdminBlock :title="'Duplicate ' +  ( index + 1 ) + ' of Job'">

                <div class="row">
                    <div class="col-lg-6">
                        <InputTextField
                            label="Purchase Order (Client Ref)"
                            name="client_ref"
                            v-model="duplicate.client_ref"
                        />
                    </div>
                    <div class="col-lg-6">
                        <ContractSelect
                            :customer="job.customer"
                            v-model="duplicate.selectedContract"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="form-group mb-4">
                            <label :for="'routes_' + index" class="form-label">
                                <strong>
                                    Route
                                </strong>
                            </label>
                            <select
                                :name="'routes_' + index"
                                :id="'routes_' + index"
                                class="form-select"
                                aria-label="Default select example"
                                v-model="duplicate.selectedRoute"
                            >
                                <option value="orig">
                                    From: {{ job.collection_location }}. To: {{ job.delivery_location }}
                                </option>
                                <option value="rev">
                                    From: {{ job.delivery_location }}. To: {{ job.collection_location }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="form-group mb-4">
                            <label>
                                <strong>
                                    Vehicle
                                </strong>
                            </label>
                            <div class="d-flex align-items-end gap-3">
                                <div class="flex-grow-1">
                                    <VehicleSelect
                                        v-model="duplicate.selectedVehicle"
                                        :customer="job.customer"
                                        :vehicle="duplicate.selectedVehicle"
                                        :auto-select-single-vehicle="false"
                                        no-label
                                        remove-margin
                                    />
                                </div>
                                <div class="flex-shrink-0">
                                    <span
                                        class="btn btn-secondary"
                                        data-bs-toggle="modal"
                                        data-bs-target="#duplicate_vehicle_modal"
                                    >
                                        Create
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-group">
                            <p class="mb-4">Vehicle will be
                                <label class="" style="">
                                    <input type="radio" name="transported" v-model="duplicate.transported" value="0" />
                                    <strong>
                                        Driven
                                    </strong>
                                </label>
                                <label class="" style="">
                                    <input type="radio" name="transported" v-model="duplicate.transported" value="1" />
                                    <strong>
                                        Transported
                                    </strong>
                                </label>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-6">
                        <div class="form-group mb-4">
                            <label :for="'notes_' + index">
                                <strong>
                                    Internal Notes
                                </strong>
                            </label>
                            <textarea
                                :name="'notes_' + index"
                                :id="'notes_' + index"
                                class="form-control"
                                rows="3"
                                placeholder="Notes"
                                v-model="duplicate.notes"
                            ></textarea>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="form-group mb-4">
                            <label for="initial_driver_notes">
                                <strong>
                                    Driver Notes
                                </strong>
                            </label>
                            <textarea
                                name="initial_driver_notes"
                                id="initial_driver_notes"
                                class="form-control"
                                rows="3"
                                placeholder="Internal Notes"
                                v-model="duplicate.initial_driver_notes"
                            ></textarea>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-6">
                        <div class="form-group mb-4">
                            <label for="collection_date" class="form-label">
                                <strong>
                                    Collection Date
                                </strong>
                            </label>
                            <input
                                type="text"
                                name="collection_date"
                                id="collection_date"
                                class="form-control js-flatpickers"
                                v-model="duplicate.collectionDate"
                            >
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="form-group mb-4">
                            <label for="delivery_date" class="form-label">
                                <strong>
                                    Delivery Date
                                </strong>
                            </label>
                            <input
                                type="text"
                                name="delivery_date"
                                id="delivery_date"
                                class="form-control js-flatpickers"
                                v-model="duplicate.deliveryDate"
                            >
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-6">
                        <JobTime
                            title="Collection Time"
                            :time="job.collection_time"
                            @update-time="(value) => updateCollectionTime(index, value)"
                        />
                    </div>
                    <div class="col-lg-6">
                        <JobTime
                            title="Delivery Time"
                            :time="job.delivery_time"
                            @update-time="(value) => updateDeliveryTime(index, value)"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-6">
                        <div class="form-group mb-4">
                            <ContactSelect
                                title="Collection Contact"
                                :customer="job.customer"
                                v-model="duplicate.selectedCollectionContact"
                            />
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="form-group mb-4">
                            <ContactSelect
                                title="Delivery Contact"
                                :customer="job.customer"
                                v-model="duplicate.selectedDeliveryContact"
                            />
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-6">
                        <div class="form-group">
                            <ContractSelect
                                :customer="job.customer"
                                v-model="duplicate.selectedContract"
                            />
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="form-group mb-4">
                            <label>
                                <strong>
                                    Price
                                </strong>
                            </label>
                            <div class="input-group">
                                <span class="input-group-text">&pound;</span>
                                <input
                                    class="form-control"
                                    placeholder="0.00"
                                    name="price"
                                    v-model="duplicate.price"
                                    type="text"
                                    id="price">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="checkbox checkbox-primary">
                                    <input
                                        type="checkbox"
                                        id="price_includes_fuel"
                                        name="price_includes_fuel"
                                        class="me-2"
                                        v-model="duplicate.priceIncludesFuel"
                                    />
                                    <label for="price_includes_fuel">
                                        Price Includes Fuel
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="checkbox checkbox-primary">
                                    <input
                                        type="checkbox"
                                        id="price_includes_adblue"
                                        name="price_includes_adblue"
                                        class="me-2"
                                        v-model="duplicate.priceIncludesAdblue"
                                    />
                                    <label for="price_includes_adblue">
                                        Price Includes Adblue
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </AdminBlock>
        </div>

        <AdminBlock>
            <div class="d-flex justify-content-end">
                <a :href="showRoute" class="btn btn-danger me-2">
                    Cancel
                </a>
                <a :href="indexRoute" class="btn btn-secondary me-2">
                    View All Jobs
                </a>
                <button type="button" @click="submitForm" class="btn btn-success">
                    Save
                </button>
            </div>
        </AdminBlock>

        <VehicleModal
            identifier="duplicate"
            :customer="job.customer"
            @vehicle-created="handleVehicleCreated"
        />


    </div>

</template>

<style scoped>
.sticky-button {
    position: sticky;
    top: 75px;
    z-index: 100;
    height: 60px;
    transition: box-shadow 0.3s ease;
}

.sticky-button.is-sticky {
    box-shadow: 0 10px 15px 15px rgba(0,0,0,0.1);
}
</style>

<script setup>

import { ref, computed, onMounted, onBeforeUnmount, nextTick } from 'vue';
import axios from "axios";
import Swal from "sweetalert2";
import flatpickr from "flatpickr";
import AdminBlock from "@/components/movements/components/AdminBlock.vue";
import ContractSelect from "@/components/movements/components/ContractSelect.vue";
import InputTextField from "@/components/movements/components/InputTextField.vue";
import JobTime from "@/components/movements/components/JobTime.vue";
import VehicleSelect from "@/components/movements/components/VehicleSelect.vue";
import ContactSelect from "@/components/movements/components/ContactSelect.vue";
import VehicleModal from "@//components/movements/components/VehicleModal.vue";

const props = defineProps({
    job: {
        type: Object,
        required: true
    },
});

const duplicateButton = ref(null);
const isSticky = ref(false);
const duplicates = ref([createNewDuplicate()]);

const indexRoute = computed(() => route('movements.jobs.index'));
const showRoute = computed(() => route('movements.jobs.show', props.job));
const duplicateRoute = computed(() => route('api.movements.jobs.duplicate', { job: props.job.id }));

function createNewDuplicate() {
    return {
        selectedRoute: 'orig',
        selectedContract: props.job.contract ?? null,
        selectedVehicle: null,
        transported: Number(props.job.transported ?? 0),
        selectedContact: props.job.contact ?? null,
        selectedCollectionContact: props.job.collection_contact ?? null,
        selectedDeliveryContact: props.job.delivery_contact ?? null,
        collectionDate: props.job.collection_date ?? null,
        collectionTime: props.job.collection_time ?? null,
        deliveryDate: props.job.delivery_date ?? null,
        deliveryTime: props.job.delivery_time ?? null,
        client_ref: props.job.client_ref ?? '',
        notes: props.job.notes ?? '',
        initial_driver_notes: props.job.initial_driver_notes ?? '',
        price: props.job.price,
        priceIncludesFuel: Boolean(props.job.price_includes_fuel ?? false),
        priceIncludesAdblue: Boolean(props.job.price_includes_adblue ?? false),
    };
}

function handleScroll() {
    const button = duplicateButton.value;
    const buttonRect = button.getBoundingClientRect();
    isSticky.value = buttonRect.top <= 75;
}

function addDuplicate() {
    duplicates.value.push(createNewDuplicate());
    nextTick(() => {
        flatpickr('.js-flatpickers', {
            dateFormat: "Y-m-d",
            enableTime: false,
            altInput: true,
        });
    });
}

function handleVehicleCreated(vehicle) {
    const lastDuplicate = duplicates.value[duplicates.value.length - 1];
    lastDuplicate.selectedVehicle = vehicle.data;
}

function updateCollectionTime(index, time) {
    duplicates.value[index].collectionTime = time;
}

function updateDeliveryTime(index, time) {
    duplicates.value[index].deliveryTime = time;
}

async function submitForm() {
    try {
        duplicateButton.value.disabled = true;

        const formData = new FormData();

        duplicates.value.forEach((duplicate, index) => {
            formData.append(`duplicates[${index}][route]`, duplicate.selectedRoute);
            formData.append(`duplicates[${index}][contract_id]`, duplicate.selectedContract?.id);
            formData.append(`duplicates[${index}][vehicle_id]`, duplicate.selectedVehicle?.id);
            formData.append(`duplicates[${index}][transported]`, Number(duplicate.transported));
            formData.append(`duplicates[${index}][collectioncontact_id]`, duplicate.selectedCollectionContact?.id);
            formData.append(`duplicates[${index}][deliverycontact_id]`, duplicate.selectedDeliveryContact?.id);
            formData.append(`duplicates[${index}][collection_date]`, duplicate.collectionDate);
            formData.append(`duplicates[${index}][collection_time]`, duplicate.collectionTime);
            formData.append(`duplicates[${index}][delivery_date]`, duplicate.deliveryDate);
            formData.append(`duplicates[${index}][delivery_time]`, duplicate.deliveryTime);
            formData.append(`duplicates[${index}][client_ref]`, duplicate.client_ref);
            formData.append(`duplicates[${index}][notes]`, duplicate.notes);
            formData.append(`duplicates[${index}][initial_driver_notes]`, duplicate.initial_driver_notes);
            formData.append(`duplicates[${index}][price]`, duplicate.price);
            formData.append(`duplicates[${index}][price_includes_fuel]`, Number(duplicate.priceIncludesFuel));
            formData.append(`duplicates[${index}][price_includes_adblue]`, Number(duplicate.priceIncludesAdblue));
        });

        const response = await axios.post(duplicateRoute.value, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        await Swal.fire({
            toast: true,
            position: 'top-end',
            title: 'Job Duplicated',
            text: 'The job has been duplicated successfully',
            icon: 'success',
            confirmButtonText: 'OK',
            confirmButtonColor: '#28a745',
            width: '600px',
            timer: 1500,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer);
                toast.addEventListener('mouseleave', Swal.resumeTimer);
            },
        })
            .then(() => {
                window.location.href = response.data.redirect_url;
            });

    } catch (error) {
        const errorMessages = error.response.data.errors;

        let allErrors = '';

        Object.entries(errorMessages).forEach(([, messages]) => {
            messages.forEach(errorMessage => {
                allErrors += '<p class="mb-0">' + errorMessage + '</p>';
            });
        });

        await Swal.fire({
            toast: true,
            position: 'top-end',
            title: 'Error duplicating job',
            html: allErrors,
            icon: 'error',
            confirmButtonText: 'OK',
            confirmButtonColor: '#dc3545',
            width: '600px',
        });

        duplicateButton.value.disabled = false;
    }
}
</script>
